
const html = document.querySelector('HTML')
const body = document.querySelector('BODY')

const breakpoints = [[500, 'Smartphone'], [1300, 'Tablet'], [6000, 'Desktop'],]

export { html, body, breakpoints}
